var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnclogging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:.19px;}.cls-2{fill:#f9dcac;}.cls-3{fill:#eafcff;}.cls-4{fill:#eee;}.cls-5{fill:#ffe2ab;}.cls-6{fill:#fff2db;}.cls-7{fill:#ffd89a;}.cls-8{fill:#fbcd7a;}.cls-9,.cls-10{fill:#bbd9fa;}.cls-11{fill:#c0e0e4;}.cls-12{fill:#c8e2fc;}.cls-13{fill:#41939e;}.cls-10{opacity:.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unclogging"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lavabo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m46.35,12.23L4.86,36.04l33.49,19.36,41.43-23.71L46.35,12.23Zm-7.61,38.39l-12.02-7.01-9.9-5.77,33.11-19.08,21.86,12.56-9.97,5.82-23.09,13.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "79.79 31.69 79.79 33.27 38.35 57.03 4.86 37.95 4.86 36.04 38.35 55.4 79.79 31.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "79.79 69.43 33.35 96.29 0 76.71 47.7 54.67 79.79 69.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m99.11,80.29l-52.87-.12h0c2.91-3.05,6.35-5.6,9.83-7.69l37.09.79c-1.05,2.94,4.1,3.53,4.1,3.53,3.49.78,3.07,2.25,1.85,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m93.16,73.28l-37.09-.79c9.54-5.74,19.39-8.08,19.39-8.08,4.87-1.45,7.56-.55,7.56-.55,0,0,4.78,1.09,3.08,2.55-1.69,1.46-1.43,2.36-1.43,2.36.19,3.73,4.87,2.84,4.87,2.84,0,0,5.06-1.65,3.69,1.46-.03.07-.06.14-.08.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m96,82.45c-.69.34-3.9,1.94-7.74,4h-37.82c.2-.68-.47-1.09-2.86-.85-4.13.41-4.15-1.25-3.3-2.84l51.73-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m50.44,86.45h37.82c-1.79.97-3.72,2.03-5.6,3.12-6.43,3.73-12.91,3.59-14.42,3.4-1.51-.19-1.37-.99-.89-1.56.48-.57,0-1.27,0-1.27,0,0-1.33-1.61-8.14,3.59-6.81,5.2-14.28,4.82-14.28,4.82-11.91,0,.57-7.94.57-7.94,0,0,4.51-2.7,4.94-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m99.11,80.29c-1.14,1.15-2.98,2.1-2.98,2.1,0,0-.05.02-.13.06h0l-51.73.31c.67-1.27,1.87-2.49,1.97-2.59l52.87.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "38.35 57.03 38.35 93.29 38.24 93.35 4.86 73.89 4.86 37.95 38.35 57.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.79 33.27 79.79 69.43 38.35 93.29 38.35 57.03 79.79 33.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "71.79 31.31 61.82 37.13 49.93 30.28 49.93 18.75 71.79 31.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.93 18.75 49.93 30.28 26.72 43.61 16.82 37.84 49.93 18.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "61.82 37.13 38.73 50.61 26.72 43.61 49.93 30.28 61.82 37.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.35,
    y1: 93.35,
    x2: 38.35,
    y2: 93.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "59.39 81.17 58.96 81.42 58.96 45.21 59.39 44.97 59.39 81.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m55.2,61.41v-7.74h0v-1.75c0-.23-.19-.42-.42-.42s-.42.19-.42.42v1.09l-.85-.38c-.21-.1-.46,0-.56.21-.1.21,0,.46.21.56l1.2.54v6.81l-.85-.38c-.21-.1-.46,0-.56.21-.1.21,0,.46.21.56l1.2.54v1.23c0,.23.19.42.42.42s.42-.19.42-.42v-1.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m63.75,56.26v-7.74h0v-1.75c0-.23-.19-.42-.42-.42s-.42.19-.42.42v1.09l-.85-.38c-.21-.1-.46,0-.56.21-.1.21,0,.46.21.56l1.2.54v6.81l-.85-.38c-.21-.1-.46,0-.56.21-.1.21,0,.46.21.56l1.2.54v1.23c0,.23.19.42.42.42s.42-.19.42-.42v-1.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m33.35,9.62v15.06c0,.27-.61.49-1.36.49s-1.36-.22-1.36-.49v-15.06c0-.27.61-.49,1.36-.49s1.36.22,1.36.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m33.89,24.68c0,.25-.37.47-.93.59-.28.06-.62.1-.97.1s-.69-.04-.97-.1c-.56-.12-.93-.34-.93-.59,0-.19.21-.36.54-.48v.48c0,.27.61.49,1.36.49s1.36-.22,1.36-.49v-.48c.34.12.54.29.54.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m33.89,24.68v1.17c0,.38-.85.69-1.9.69s-1.9-.31-1.9-.69v-1.17c0,.25.37.47.93.59.28.06.62.1.97.1s.69-.04.97-.1c.56-.12.93-.34.93-.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "45.73 13.98 44.04 31.15 24.49 42.4 38.51 50.61 64.02 35.99 49.93 27.94 47.27 29.52 46.8 13.98 45.73 13.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m46.26,14.27c-.35,0-.63-.28-.63-.63,0-7.29-4.12-10.67-7.94-10.73-1.32-.02-2.38.38-3.2,1.18-1.82,1.78-1.86,5.01-1.86,5.04,0,.35-.29.63-.63.63h0c-.35,0-.63-.29-.63-.64,0-.15.04-3.78,2.24-5.94,1.07-1.05,2.45-1.57,4.11-1.55,2.85.04,5.25,1.38,6.93,3.87,1.46,2.16,2.26,5.05,2.26,8.13,0,.35-.28.63-.63.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnclogging);
export default __webpack_public_path__ + "static/media/unclogging.830f5b6be193d44bff25ee4e8d9a8a0b.svg";
export { ForwardRef as ReactComponent };